import { Arbeitsbereiche } from '@/domain/mitarbeiter/features/anlageassistent/content/Person/Arbeitsbereiche';
import { Kontakt } from '@/domain/mitarbeiter/features/anlageassistent/content/Person/Kontakt';
import { Person } from '@/domain/mitarbeiter/features/anlageassistent/content/Person/Persoenliches';
import { Zusammenfassung } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Zusammenfassung';
import {
  AnlageassistentContextType,
  SubStepKey,
} from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { faListUl, faUser } from '@fortawesome/pro-regular-svg-icons';
import { TFunction } from 'i18next/typescript/t';

export function createSubStep(subStepConfig: {
  title: string;
  key: SubStepKey;
  content: React.ReactNode;
}) {
  return subStepConfig;
}

export function createContextConfig({
  t,
}: {
  t: TFunction<'translation', undefined>;
}): AnlageassistentContextType['state'] {
  return {
    currentStepIndex: 0,

    currentSubStepIndex: 0,
    steps: [
      {
        type: 'step',
        key: 'person',
        title: t('domain.mitarbeiter.create.steps.person.title'),
        icon: faUser,

        subSteps: [
          createSubStep({
            title: t(
              'domain.mitarbeiter.create.steps.person.persoenliches.title',
            ),
            key: 'person.persoenliches',

            content: <Person />,
          }),
          createSubStep({
            title: t('domain.mitarbeiter.create.steps.person.kontakt.title'),
            key: 'person.kontakt',

            content: <Kontakt />,
          }),
          createSubStep({
            title: t(
              'domain.mitarbeiter.create.steps.person.arbeitsbereiche.title',
            ),
            key: 'person.arbeitsbereiche',

            content: <Arbeitsbereiche />,
          }),
        ],
      },

      {
        type: 'summary',
        key: 'summary',
        title: t('domain.mitarbeiter.create.steps.zusammenfassung'),
        icon: faListUl,
        content: <Zusammenfassung />,
      },
    ],
  };
}
